import cn from 'classnames';
import { createElement, forwardRef } from 'react';

import { usePdfHelpers } from 'src/hooks/usePdfHelpers';

import styles from './RichText.module.scss';

export type RichTextProps = {
  field: string | undefined;
  styled?: boolean;
  tag?: keyof JSX.IntrinsicElements;
  className?: string;
  noDefaultBodyStyle?: boolean;
};

const RichText = forwardRef<HTMLDivElement, RichTextProps>(function BaseHelpersRichText(
  props: RichTextProps,
  ref
): JSX.Element {
  const { styled = true, className, field, tag = 'div', noDefaultBodyStyle } = props;
  const { isPdf } = usePdfHelpers();

  const customClassName = className;

  if (field) {
    return createElement(tag, {
      className: cn(customClassName, {
        [styles.main]: styled,
        [styles['no-default-body-style']]: noDefaultBodyStyle,
      }),
      'data-pdf': isPdf ? 'true' : undefined,
      ref: ref,
      dangerouslySetInnerHTML: {
        __html: field,
      },
    });
  }
  return <></>;
});

export default RichText;
